import { fork } from 'redux-saga/effects';

import country from './country';
import specialtiesSaga from './specialties';


const sagas = [country, specialtiesSaga];

export default function* rootSaga() {
  yield sagas.map(saga => fork(saga));
}
